var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RowBuilder from './RowBuilder';
import parseRequired from './parseRequired';

var FormBuilder = function (_Component) {
  _inherits(FormBuilder, _Component);

  function FormBuilder() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormBuilder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.listeners = {}, _this.setError = function (_ref) {
      var name = _ref.name,
          message = _ref.message;

      var errors = _this.get('errors') || [];
      var current = errors.find(function (e) {
        return e.name === name;
      });
      var filtered = errors.filter(function (e) {
        return e.name !== name;
      });

      // Check message to see if we're setting or unsetting the error
      if (!message) {
        if (current) {
          _this.set('errors', filtered);
        }
        return;
      }

      // We're setting but check that we're actually making a change
      if (!current || current.message !== message) {
        var error = { message: message, name: name };
        _this.set('errors', [].concat(filtered, [error]));
      }
    }, _this.getErrors = function () {
      // Create a copy of the errors set in the state. We don't modify this.
      var errors = (_this.get('errors') || []).slice(0);

      function isAlreadyInErrors(name) {
        return Boolean(errors.find(function (e) {
          return e.name === name;
        }));
      }

      var allRequired = _this.props.required || [];
      if (typeof allRequired === 'function') {
        allRequired = allRequired(_this.props.form);
      }

      for (var _iterator = allRequired, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref2 = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref2 = _i.value;
        }

        var required = _ref2;

        // If we have a specific error already for the field, we don't
        // bother checking if it's "required" and has a value set
        if (isAlreadyInErrors(required.name)) {
          continue;
        }

        // If we only require this field to be filled if another field is
        // equal to a specific value, do that check.
        // e.g. require "Are You Pregnant" only if "Gender" === Female"
        if (required.only_if) {
          var _required$only_if = required.only_if,
              name = _required$only_if.name,
              value = _required$only_if.value;

          if (_this.get(name) !== value) {
            continue;
          }
        }

        // We append the missing required fields to the copy of errors
        if (_this.get(required.name) === '') {
          errors.push(required);
        }
      }

      return errors;
    }, _this.get = function (key) {
      return key && _this.props.store.state[key] || '';
    }, _this.set = function (key, value) {
      // No key! Can't do anything useful.
      if (!key) return;

      // Value not yet defined, return a function that captures the key
      if (value === undefined) {
        return function (v) {
          return _this.set(key, v);
        };
      }

      var _this$props = _this.props,
          onSubmit = _this$props.onSubmit,
          onUpdate = _this$props.onUpdate;

      // If calling set() on a submit button, handle specially

      if (key === 'submit' && value) {
        if (onSubmit) onSubmit(_this.props.store.state);
        return;
      }

      // Create an update object
      var update = {};
      update[key] = value;

      // Apply to our state
      _this.props.store.setState(update);

      // Handle the complete state to the onUpdate call
      if (onUpdate) {
        onUpdate(_extends({}, _this.props.store.state, update), _extends({}, update));
      }

      if (key in _this.listeners) {
        for (var _iterator2 = Object.keys(_this.listeners[key]), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
          var _ref3;

          if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
          } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
          }

          var subKey = _ref3;

          var listener = _this.listeners[key][subKey];
          listener(key, value);
        }
      }
    }, _this.setListener = function (key, name, listener) {
      if (!(key in _this.listeners)) {
        _this.listeners[key] = {};
      }

      if (listener) {
        _this.listeners[key][name] = listener;
      } else {
        delete _this.listeners[key][name];
      }
    }, _this.render = function () {
      return React.createElement(
        'div',
        { className: _this.props.className },
        _this.props.form.map(function (row, i) {
          return React.createElement(RowBuilder, { colSize: _this.props.colSize, key: i, row: row });
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormBuilder.prototype.getChildContext = function getChildContext() {
    return {
      customFields: this.props.customFields || this.context.customFields || {},
      form: this.context.form || this
    };
  };

  return FormBuilder;
}(Component);

FormBuilder.contextTypes = {
  customFields: PropTypes.object,
  form: PropTypes.object
};

FormBuilder.childContextTypes = {
  customFields: PropTypes.object,
  form: PropTypes.object
};

FormBuilder.defaultProps = {
  colSize: 'md',
  required: parseRequired
};

FormBuilder.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  colSize: PropTypes.string.isRequired,
  customFields: PropTypes.object,
  form: PropTypes.array.isRequired,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  required: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    only_if: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  }))]),
  store: PropTypes.object.isRequired
} : {};

export default FormBuilder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/FormBuilder.js
// module id = 102
// module chunks = 0